<template>
  <div class="product-inquiry">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <b-card no-body>
        <b-card-header>
          <strong>登録</strong>
        </b-card-header>
        <b-card-body>
          <b-form-group label="送信元メールアドレス:" label-cols-md="3" label-align-md="right">
            <FormValidatorEmail name="送信元メールアドレス" :form="$v.form.email" />
          </b-form-group>
          <b-form-group label="件名:" label-cols-md="3" label-align-md="right">
            <FormValidatorText name="件名" :form="$v.form.subject" />
          </b-form-group>
          <b-form-group label="問い合わせ内容:" label-cols-md="3" label-align-md="right">
            <FormValidatorTextarea name="問い合わせ内容" :form="$v.form.content" :rows="10" />
          </b-form-group>
        </b-card-body>
        <b-card-footer>
          <b-button type="submit" variant="primary">送信</b-button>
          <b-button type="reset" variant="outline-primary">リセット</b-button>
        </b-card-footer>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { required, email, maxLength, decimal, integer, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'ProductInquiry',

  data() {
    return {
      form: {
        email: '',
        subject: '',
        content: '',
      },
    };
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
    }),
  },

  validations: {
    form: {
      email: {
        required,
        email,
        maxLength: maxLength(255),
      },
      subject: {
        maxLength: maxLength(255),
      },
      content: {
        required,
        maxLength: maxLength(65536),
      },
    },
  },

  mounted() {
    this.form.email = this.auth.email;
  },

  methods: {
    onSubmit(evt) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.$utils.confirm('問い合わせ送信', '送信してよろしいですか？', () => {
        this.$store.dispatch('products/sendInquiry', {
          id: this.$route.params.id,
          email: this.form.email,
          subject: this.form.subject,
          content: this.form.content,
        });
      });
    },

    onReset(evt) {
      this.$v.form.$reset();
      this.form.email = this.auth.email;
      this.form.subject = '';
      this.form.content = '';
    },
  },
};
</script>

<style scoped>
</style>
